<template>
<div>
  <div 
    v-for="(comprador, i) in compradores"
    :key="'documentacion'+i"
  >
    <v-layout column>
      <v-layout v-if="(esAdministrador || esComercial) && moduloOrden.scoring && comprador.titular" column>
        <o-medium-title>{{$t('reservas.documentacion.resultadoViabilidad')}}</o-medium-title>
        <v-layout justify-center>
          <v-btn
            @click.stop
            :href="$scoringDocumento(reserva.id)" target="_blank"
            color="primary"
          >
            {{$t('reservas.documentacion.verScoring')}}
          </v-btn>
        </v-layout>
      </v-layout>
      <o-medium-title>{{$t('reservas.documentacion.docTitle', {reserva: reserva.cod_tipo_operacion === 'VTA' ? $t('reservas.documentacion.comprador') : $t('reservas.documentacion.arrendatario'), i: i+1, comprador: nombreComprador(comprador)})}}</o-medium-title>
      <DocumentacionComprador
        v-if="!moduloOrden.aportarDocumentosFormaFlexible" 
        ref="documentacion"
        :validacion="validacionDocumentacion != null"
        :comprador.sync="comprador"
        :revisando="revisando"
        :ver="documentacionVer"
        :guardando="guardando"
        @comprobarExtra="setDocExtraValida"
      />
      <DocumentacionFlexible 
        v-else
        ref="documentacion"
        :validacion="validacionDocumentacion != null"
        :comprador.sync="comprador"
        :revisando="revisando"
        :ver="documentacionVer"
        :guardando="guardando"
      />
    </v-layout>
  </div>
  <v-slide-y-transition>
    <div v-if="!moduloOrden.aportarDocumentosFormaFlexible" v-show="!((revisando || documentacionVer) && documentosExtra.length == 0)">
      <o-medium-title>{{$t('reservas.documentacion.docExtra')}}</o-medium-title>
      <div :class="claseSeccionValidacionDocumento(documentacionExtra, revisando || documentacionRechazada)"
      >
        <v-layout mb-3>
          <label 
            class="theme--light v-label"
            :class="!documentacionExtraValida ? 'error--text' : ''"
          >
            {{$t('reservas.documentacion.docExtraRequerida')}}
          </label>
        </v-layout>
        <v-layout wrap mb-3>
          <v-flex 
            xs12 sm12 md12 lg12
            mb-2
          >
            <FileUploader
              style="height:168px"
              :maxNum="10"
              v-model="documentosExtra"
              :deletable="!documentacionVer && !revisando && !guardando && !(documentacionExtra != null && documentacionExtra.validado && (revisando || documentacionRechazada))"
              :disabled="documentacionVer || revisando || guardando || (documentacionExtra != null && documentacionExtra.validado && documentacionRechazada)"
              @input="comprobarDocExtra()"
            />
          </v-flex>
        </v-layout>
        <v-flex shrink v-if="revisando">
          <v-btn
            block
            color="primary"
            @click="documentacionExtraValidada = !documentacionExtraValidada"
            hide-details
          >
          {{documentacionExtraValidada ? $t('reservas.documentacion.rechazarDoc') : $t('reservas.documentacion.validarDoc')}}
          </v-btn>
        </v-flex>
      </div>
    </div>
  </v-slide-y-transition>
  <!-- Ver contrato -->
  <v-layout v-if="documentacionVer && reserva.contratoKyc != null" column>
    <o-medium-title>{{$t('reservas.documentacion.contratoKyc')}}</o-medium-title>
    <v-layout justify-center>
      <v-btn
        large
        color="primary"
        @click.stop
        :href="$contrato(reserva.contratoKyc.documentoFirmado.documento.id)"
        target="_blank"
      >
        {{$t('reservas.documentacion.verContrato')}}
      </v-btn>
    </v-layout>
  </v-layout>
</div>
</template>
<script>
import { mapGetters } from 'vuex'
import FileUploader from '@/components/generic/fileUploader/FileUploader'
import DocumentacionComprador from './DocumentacionComprador'
import DocumentacionFlexible from './DocumentacionFlexible'
import MixinComprador from '@/mixins/comprador'
import MixinDocumentacion from '@/mixins/documentacion'
import MixinEstadoDocumentacion from '@/mixins/estadosReserva/estadoDocumentacion'
import MixinEstadoValidacionDocumentacion from '@/mixins/estadosReserva/estadoValidacionDocumentacion'
import rules from '@/mixins/rules'

export default {
  mixins: [rules, MixinComprador, MixinDocumentacion, MixinEstadoDocumentacion, MixinEstadoValidacionDocumentacion],
  props: {
    compradores: {
      type: Array,
      default: () => []
    },
    guardando: {
      type: Boolean,
      default: false
    },
    tipo: {
      type: String,
      default: 'documentacion'
    },
    mostrarDocExtra: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      documentacionExtraValida: true
    }
  },
  components: {
    DocumentacionComprador,
    DocumentacionFlexible,
    FileUploader
  },
  computed: {
    ...mapGetters({
      reserva: 'reservas/_id/getActual'
    }),
    revisando () {
      switch (this.tipo) {
        case 'validacionDocumentacion':
          return this.validacionEnRevision
        case 'documentacion':
        case 'contrato':
        case 'pbc':
          return false
        default:
          console.log(this.$t('reservas.comprador.tipoIncorrecto'))
          return false
      }
    }
  },
  methods: {
    setDocExtraValida (documentosValidos) {
      const index = this.getTitular ? this.getTitular.documentacion.findIndex(d => this.esDocumentacionExtra(d.carpeta)) : -1
      this.documentacionExtraValida = index !== -1 ? documentosValidos[index] : true
    },
    comprobarDocExtra () {
      const indexComprador = this.compradores.findIndex(x => x.titular)
      const index = this.getTitular ? this.getTitular.documentacion.findIndex(d => this.esDocumentacionExtra(d.carpeta)) : -1
      this.documentacionExtraValida = index !== -1 ? this.compradores[indexComprador].documentacion[index].documento.length === 0 || this.$refs.documentacion[indexComprador].inputDocumento(index) : true
    },
    documentosSonValidos (i) {
      return this.$refs.documentacion[i].comprobarDocumentacion()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/reservas/documentacion/BaseDocumentacion.vue